// src/redux/slices/favoritesSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Async thunk to fetch favorites from your backend (if needed)
export const fetchFavorites = createAsyncThunk(
  'favorites/fetchFavorites',
  async (_, { rejectWithValue }) => {
    try {
      // Replace with your actual API endpoint
      const response = await axios.get('/api/favorites');
      return response.data; // Expecting an array of favorite items
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to fetch favorites');
    }
  }
);

const favoritesSlice = createSlice({
  name: 'favorites',
  initialState: {
    items: [
      // Example favorites (you might load these from an API instead)
      {
        id: 1,
        name: 'Hoodies',
        price: '50 starting at $11.99',
        img: '/assets/images/fashion-hoodie.jpg',
      },
      {
        id: 2,
        name: 'Bags',
        price: '10 starting at $5.99',
        img: '/assets/images/cat-home.jpg',
      },
      {
        id: 3,
        name: 'Cap',
        price: '20 starting at $8.99',
        img: '/assets/images/cat-fashion.jpg',
      },
      {
        id: 4,
        name: 'Tote Bag',
        price: '30 starting at $9.99',
        img: '/assets/images/cat-home.jpg',
      },
      {
        id: 5,
        name: 'Combo',
        price: 'Various starting at $14.99',
        img: '/assets/images/fashion-hoodie.jpg',
      },
      // ... other favorite items
    ],
    loading: false,
    error: null,
  },
  reducers: {
    // Add a new favorite
    addFavorite: (state, action) => {
      state.items.push(action.payload);
    },
    // Remove a favorite by its id
    removeFavorite: (state, action) => {
      state.items = state.items.filter(item => item.id !== action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFavorites.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFavorites.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchFavorites.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { addFavorite, removeFavorite } = favoritesSlice.actions;
export default favoritesSlice.reducer;
